import { cloneElement, ReactElement } from "react";

// material-ui
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import useScrollTrigger from "@mui/material/useScrollTrigger";

// project imports
import useConfig from "hooks/useConfig";
import Navigation from "./DrawerContent/Navigation";

// ==============================|| HORIZONTAL MENU LIST ||============================== //

interface ElevationScrollProps {
  children: ReactElement;
  window?: Window | Node;
}

function ElevationScroll({ children, window }: ElevationScrollProps) {
  const theme = useTheme();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window!,
  });

  theme.shadows[4] = theme.customShadows.z1;

  return cloneElement(children as ReactElement<{ elevation?: number }>, {
    elevation: trigger ? 4 : 0,
  });
}

// ==============================|| HORIZONTAL MENU LIST ||============================== //

export default function CustomAppBar() {
  const { container } = useConfig();

  return (
    <ElevationScroll>
      <AppBar
        sx={{
          top: 60,
          bgcolor: "background.paper",
          width: "100%",
          height: 62,
          justifyContent: "center",
          borderTop: "1px solid",
          borderTopColor: "divider",
          borderBottom: "1px solid",
          borderBottomColor: "divider",
          zIndex: 1098,
          color: "grey.500",
        }}
      >
        <Container maxWidth={container ? "xl" : false}>
          <Stack direction="row" sx={{ alignItems: "center" }}>
            <Navigation />
          </Stack>
        </Container>
      </AppBar>
    </ElevationScroll>
  );
}
